import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/index.css";
import App from "@/App";
import PrivacyPage from "@/pages/PrivacyPage";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/*" element={<App />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
);

// PWA: registra il Service Worker per uso offline (solo in produzione)
serviceWorkerRegistration.register({
  onSuccess: () => {},
  onUpdate: (registration) => {
    // Nuova versione disponibile: attiva subito e ricarica
    const reloadOnce = () => {
      window.location.reload();
      navigator.serviceWorker.removeEventListener("controllerchange", reloadOnce);
    };
    navigator.serviceWorker.addEventListener("controllerchange", reloadOnce);
    if (registration.waiting) {
      registration.waiting.postMessage({ type: "SKIP_WAITING" });
    }
  },
});
